module.exports = __webpack_public_path__ + "img/3x.7ad8c32.jpg";